<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">İndirim</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body" tabindex="0" ngbAutofocus>
    <form [formGroup]="discountRateForm">
        <label for="discountRate">% Oranı Giriniz</label>
        <div class="form-group">
            <input type="number" id="discountRate" formControlName="discountRate" placeholder="Oran giriniz."
                class="form-control" />

            <!-- Hata Mesajları -->
            <div *ngIf="discountRateForm.get('discountRate')?.touched && discountRateForm.get('discountRate')?.invalid"
                class="text-danger mt-1 small">
                <div *ngIf="discountRateForm.get('discountRate')?.errors?.['required']">
                    Bu alan zorunludur.
                </div>
                <div *ngIf="discountRateForm.get('discountRate')?.errors?.['min']">
                    İndirim oranı 0'dan küçük olamaz.
                </div>
                <div *ngIf="discountRateForm.get('discountRate')?.errors?.['max']">
                    İndirim oranı 100'den büyük olamaz.
                </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closeModal()" rippleEffect>
        İptal
    </button>
    <button type="button" class="btn btn-success" (click)="onSubmit()" rippleEffect>
        Kaydet
    </button>
</div>